import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
import { useToast } from '@/common-utils/hooks/use-toast';
import Entity from '@/common-utils/components/renders/entity/Entity';
import actionsBeneficiaries from '../api/actionsBeneficiaries';
import { nsBeneficiaries } from '@/app/i18n/namespaces';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import BeneficiarySummary from '../components/BeneficiarySummary';

/**
 * @param {boolean} isOpen
 * @param {function} setIsOpen
 * @param {string} beneficiaryUuid
 * @param {function} setLaunchRefetch
 * @returns {JSX} ModalDeleteBeneficiary
 */
function ModalDeleteBeneficiary({ isOpen, setIsOpen, merchantAccountId, beneficiaryUuid, color, name, contracts, setLaunchRefetch }) {

    // Toast
    const { toast } = useToast();

    // API Calls
    const onSuccess = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.delete.success' namespace={nsBeneficiaries} />,
            variant: 'success'
        });
        setLaunchRefetch(true);
    };
    const onError = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.delete.error' namespace={nsBeneficiaries} />,
            variant: 'danger'
        });
    };
    const submitDeleteBeneficiary = actionsBeneficiaries.deleteBeneficiary(onSuccess, onError);

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-lg'>
                <HeaderTitle title='modal.delete.title' namespace={nsBeneficiaries} />
                <ModalBody>
                    <Entity entity='modal.delete.text' namespace={nsBeneficiaries} />
                    <div className='flex justify-center mt-4 mb-2'>
                        <BeneficiarySummary
                            color={color}
                            name={name}
                            contracts={contracts}
                        />
                    </div>
                </ModalBody>
                <FooterForm
                    onSubmit={() => submitDeleteBeneficiary.mutate({
                        contractAccessId: merchantAccountId,
                        beneficiaryUuid
                    })}
                    isSubmitting={submitDeleteBeneficiary.isLoading}
                />
            </ModalContent>;
        </Modal>
    );
}

ModalDeleteBeneficiary.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    merchantAccountId: PropTypes.string.isRequired,
    beneficiaryUuid: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    contracts: PropTypes.array.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};

export default ModalDeleteBeneficiary;